import React from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col, Label, Input } from 'reactstrap'
import i18n from "../../../i18next";

import PromotionSummary from './PromotionSummary';
import PromotionSearch from './PromotionSearch';
import { loadPromotionNames } from '../../../actions/restaurants/customerInsight/CustomerInsightAction'

class PromotionSearchSelection extends React.Component {

    state = {
        contentType: 'promotionSummary',
    }

    componentDidMount() {
        this.props.loadPromotionNames(this.props.restaurantId);
    }

    renderPromotionSearchTypeDropdown = () => {
        return (
            <Container fluid style={{ borderBottom: '1px solid rgb(33,150,214)', paddingBottom: '20px', marginBottom: '30px' }}>
                <Row>
                    <Label
                        for='promotionSelectionInput'
                        style={{ marginRight: '25px', display: 'flex', alignItems: 'center' }}
                    >
                        {i18n.t('screens:customerInsightScreen.selectTypeSearch')}
                    </Label>
                    <Col sm={3} style={{ paddingLeft: 0 }} >
                        <Input
                            type="select"
                            name="promotionSelectionInput"
                            id="promotionSelectionInput"
                            value={this.state.contentType}
                            onChange={(e) => this.setState({ contentType: e.target.value })}>
                            <option value='promotionSummary'>{i18n.t('screens:customerInsightScreen.promotionSummarySearch')}</option>
                            <option value='promotionSearch'>{i18n.t('screens:customerInsightScreen.promotionSearch')}</option>
                        </Input>
                    </ Col>
                </Row>
            </Container>
        );
    }

    render() {
        const isRestaurantInsight = (this.props.insightType && this.props.insightType ==='restaurant') ? true : false;
        return (
            <React.Fragment>
                {this.renderPromotionSearchTypeDropdown()}
                {this.state.contentType === 'promotionSummary' ?
                    <PromotionSummary restaurantId={this.props.restaurantId} isRestaurantInsight={isRestaurantInsight} customerId={this.props.customerId}/> :
                    <PromotionSearch restaurantId={this.props.restaurantId} isRestaurantInsight={isRestaurantInsight} customerId={this.props.customerId} />
                }
            </React.Fragment>
        );
    }

}

export default connect(null, { loadPromotionNames })(PromotionSearchSelection);


// WEBPACK FOOTER //
// ./src/components/restaurants/customerInsightScreen/PromotionSearchSelection.js